export default __webpack_public_path__ + "static/zdanovich-c2c3da0e73de4098a4baccd63930c783.png";